<template>
    <div class="flex items-center flex-col">
      <!-- <div class="absolute top-[50px] z-2" ref="bell">
        <a  :class="this.alertData.length != 0 && this.showAlerts == false?'bell block p-[2px] relative ml-[15px]': 'block p-[2px] relative ml-[15px]'" @click="this.showAlerts == false?
        this.showAlerts = true :
        this.showAlerts = false
        ">
        <div  v-if="this.alertData.length != 0" class="absolute z-2 right-[-5px] top-[-5px] w-[25px] bg-red-600 text-center text-white rounded-3xl hover:cursor-pointer">{{ this.alertData.length }}</div>
          <img
        class="relative w-[30px] fill-[#fff]" 
        src="../assets/images/bell_white.svg"
          /></a>
      </div> -->
    <a
      class="block w-24 h-24 my-5 mx-auto rounded-full overflow-hidden relative cursor-pointer max-l:hidden z-2"
      @click="$router.push('/profile')"
    >
      <img
        v-if="profile?.picture"
        class="w-full h-full object-cover z-2"
        :src="'https://api.tahocrm.ru/uploads/users/' + profile?.picture"
      />
      <img
        v-else
        class="w-full h-full object-cover z-2"
        style="filter: invert(1)"
        src="@/assets/images/person.png"
      />
    </a>
  <!-- </div> -->
    
    <div class="text-center relative py-4 max-l:hidden z-2">
        <span  class="uppercase text-green-500 text-sm transition-colors duration-300 hover:text-green-400 z-2">{{ roleNames[role] }}</span>
    </div>

    <ul v-if="profile" class="px-6 max-l:flex max-l:overflow-y-hidden h-max z-2 self-start">
      <li
        class="mr-30px text-white list-none group transition-colors duration-1000"
      >
        <a
          class="flex pl-9 py-3 font-latobold max-w-[200px] cursor-pointer relative anim-navbar max-l:before:hidden z-2"
          @click="goTo('/create-lead')"
        >
        Создать ЛИД
        </a>
      </li>
      <li
        class="mr-30px text-white list-none group transition-colors duration-1000"
      >
        <a
          class="flex pl-9 py-3 font-latobold max-w-[200px] cursor-pointer relative anim-navbar max-l:before:hidden z-2"
          @click="goTo('/my-leads')"
        >
        ЛИДЫ
        </a>
      </li>
      <li
        class="mr-30px text-white list-none group transition-colors duration-1000"
      >
        <a
          class="flex pl-9 py-3 font-latobold max-w-[200px] cursor-pointer relative anim-navbar max-l:before:hidden z-2"
          @click="goTo('/profile')"
        >
        Профиль
        </a>
      </li>
      
    </ul>
    <p
      class="block text-gray-400 text-xs relative text-center mt-24 max-l:hidden pb-8 z-2"
    >
      © TahoCRM 2025 (new)
    </p>
    <!--<button @click="testCron">CRON TEST</button>-->
  </div>
</template>

<script>


// import { markRaw } from "vue";
import { mapActions, mapGetters } from "vuex";
import API from "@/services/api";
import router from "@/router/router";

export default {
  name: "NavBar",

  data() {
    return {
      isDrop: false,
      icons: {
        "nav-calendar":
          '<svg><use xlink:href="@/assets/i.svg#nav-calendar"></use></svg>',
      },
      alertData: [],
      inputMessage: "",
    };
  },

  computed: {
    ...mapGetters([
      "menu",
      "profile",
      "role",
      "roleNames",
      "backM",
      "newTahobanFrontLink",
      "s",
    ]),
  },

  methods: {
    ...mapActions(["logOut", "nextRole", "backToManager", "getProfile", "showTask", "showLeadModal", "closePopup","setTask", "findTask",]),

    DropMenu() {
      this.isDrop = !this.isDrop;
    },
    localLogOut() {
      this.isDrop = false;
      this.logOut();
    },

    goTo(value){
      console.log(API.URL)
      router.push(value)
    },
    
    close() {
      this.setTask(null);
      this.findTask(this.s);

      this.closePopup();
    },

  },
   
 async mounted() {
    // await this.getProfile()
  },
};
</script>

<style>
.bell >img {
  animation: ring 1.5s; 
  animation-iteration-count: infinite;
  
}
.bell:hover >img {
  cursor: pointer;
  animation: none;
  
}
@keyframes ring {
  0% {
    -webkit-transform: rotateZ(0);
  }
  9% {
    -webkit-transform: rotateZ(30deg);
  }
  19% {
    -webkit-transform: rotateZ(-30deg);
  }
  26% {
    -webkit-transform: rotateZ(18deg);
  }
  32% {
    -webkit-transform: rotateZ(-16deg);
  }
  40% {
    -webkit-transform: rotateZ(14deg);
  }
  47% {
    -webkit-transform: rotateZ(-12deg);
  }
  55% {
    -webkit-transform: rotateZ(10deg);
  }
  62% {
    -webkit-transform: rotateZ(-8deg);
  }
  69% {
    -webkit-transform: rotateZ(6deg);
  }
  75% {
    -webkit-transform: rotateZ(-4deg);
  }
  80% {
    -webkit-transform: rotateZ(2deg);
  }
  85% {
    -webkit-transform: rotateZ(-1deg);
  }
  90% {
    -webkit-transform: rotateZ(1deg);
  }
  100% {
    -webkit-transform: rotateZ(0);
  }
}
.popAp{
  z-index: 999999;
}
</style>
